import { render, staticRenderFns } from "./shipmentreport.vue?vue&type=template&id=131fac92"
import script from "./shipmentreport.vue?vue&type=script&lang=js"
export * from "./shipmentreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports